import { Pipe, PipeTransform } from '@angular/core';
import { OrganisationDto } from '@careapp-group/ng-sdk';
import { TranslateService } from '@ngx-translate/core';

// Given a list of Org IDs, and org entities provides a brief summary of organisation names.
// eg: ['org1', 'org2', 'org3] : {'org1': {name: 'WoodCroft Care'} ...}
// Output: 'Woodcroft care and 2 others.'

@Pipe({
    name: 'organisationSummary',
    pure: true,
    standalone: false
})
export class OrganisationSummaryPipe implements PipeTransform {
  constructor(private translateService: TranslateService) {}
  public transform(ids: string[], organisations: { [key: string]: OrganisationDto }): string {
    // Handle if an ID string was given.
    if (typeof ids == 'string') {
      ids = [ids];
    }
    if (!Array.isArray(ids) || !ids.length) {
      return '';
    }

    // Organisation names
    let orgNames: string[] = [];
    if (!!organisations) {
      orgNames = ids
        .filter((id) => organisations.hasOwnProperty(id))
        .map((id) => organisations[id].name);
      orgNames.sort((a, b) => a.localeCompare(b));
    }

    // No matching organisation entities given for the IDs.
    if (orgNames.length == 0) {
      return ids.length > 1
        ? // "X Sites"
          this.translateService.instant('announcements.organisationCount.plural', {
            count: ids.length,
          })
        : // "One Site"
          this.translateService.instant('announcements.organisationCount');
    }

    // One organisation entity matches what we have in the store.
    else if (orgNames.length == 1) {
      return ids.length > 1
        ? // "Name, and N more"
          this.translateService.instant('announcements.organisationNameAndCount', {
            organisationName: orgNames[0],
            remainingCount: ids.length - 1,
          })
        : // "Name"
          orgNames[0];
    }

    // Many matching org entities.
    else if (orgNames.length > 1) {
      return ids.length > 2
        ? // "Name 1, Name 2 and N more"
          this.translateService.instant('announcements.organisationNameAndCount', {
            organisationName: orgNames.slice(0, 2).join(', '),
            remainingCount: ids.length - 2,
          })
        : // "Name 1, Name 2"
          orgNames.slice(0, 2).join(', ');
    }
  }
}
